export function initSetNewPassword() {
  const form = document.getElementById("new-password-form");
  if (!form) return;

  const formWrapper = form.closest(".new-password__wrapper");
  const formMessage = form.querySelector(".form-message");
  const submitButton = form.querySelector('button[type="submit"]');
  const originalButtonText = submitButton.textContent;

  const showMessage = (message, type) => {
    formMessage.textContent = message;
    formMessage.classList.remove("success", "error");
    formMessage.classList.add(type);
    formMessage.style.display = "block";
  };

  const showSuccessState = (message, loginUrl) => {
    const successContent = document.createElement("div");
    successContent.className = "new-password__success-message";
    successContent.innerHTML = `
      <h2 class="new-password__title">${message}</h2>
      <a href="${loginUrl}" class="link-text">
        ${setPasswordVars.messages.goToLogin}
      </a>
    `;
    formWrapper.innerHTML = "";
    formWrapper.appendChild(successContent);
  };

  const validatePassword = (password) => {
    if (!password) {
      showMessage(setPasswordVars.messages.passwordRequired, "error");
      return false;
    }

    if (password.length < 8) {
      showMessage(setPasswordVars.messages.passwordTooShort, "error");
      return false;
    }

    // Check password complexity
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);

    if (!hasUpperCase || !hasLowerCase || !hasNumbers) {
      showMessage(setPasswordVars.messages.passwordComplexity, "error");
      return false;
    }

    return true;
  };

  const validateForm = (password, confirmPassword) => {
    if (!validatePassword(password)) return false;

    if (!confirmPassword) {
      showMessage(setPasswordVars.messages.confirmRequired, "error");
      return false;
    }

    if (password !== confirmPassword) {
      showMessage(setPasswordVars.messages.passwordMismatch, "error");
      return false;
    }

    return true;
  };

  form.addEventListener("submit", async (event) => {
    event.preventDefault();

    const password = form.querySelector('input[name="password"]').value;
    const confirmPassword = form.querySelector(
      'input[name="confirm_password"]'
    ).value;
    const rpKey = form.querySelector('input[name="rp_key"]').value;
    const rpLogin = form.querySelector('input[name="rp_login"]').value;

    if (!validateForm(password, confirmPassword)) return;

    try {
      submitButton.textContent = setPasswordVars.messages.saving;
      submitButton.disabled = true;

      const formData = new FormData();
      formData.append("action", "handle_set_new_password");
      formData.append("nonce", setPasswordVars.nonce);
      formData.append("password", password);
      formData.append("rp_key", rpKey);
      formData.append("rp_login", rpLogin);

      const response = await fetch(setPasswordVars.ajaxUrl, {
        method: "POST",
        body: formData,
        credentials: "same-origin",
      });

      const data = await response.json();

      if (data.success) {
        showSuccessState(data.data.message, data.data.loginUrl);
      } else {
        showMessage(data.data.message, "error");
        submitButton.textContent = originalButtonText;
        submitButton.disabled = false;
      }
    } catch (error) {
      showMessage(setPasswordVars.messages.error, "error");
      submitButton.textContent = originalButtonText;
      submitButton.disabled = false;
    }
  });

  // Clear error message on input
  form.querySelectorAll('input[type="password"]').forEach((input) => {
    input.addEventListener("input", () => {
      formMessage.style.display = "none";
    });
  });
}

document.addEventListener("DOMContentLoaded", initSetNewPassword);
